export default Object.freeze({
  ContinueAlways: 1,
  ThrowErrorIfAnyFailed: 2,
  ThrowErrorIfAllFailed: 3,
});
